import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import { Menu, MessageSquareDot, Settings, FileText, Bell, BellDot, CheckCircle, CircleDot, X } from "lucide-react";
import { Avatar, Wrap, WrapItem, Badge } from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { clearAllNotificationApi, getNotificationApi, markAllReadNoticationApi, updateNoticationApi } from "../../Notification/NotificationApi";
import { userLogout } from "../../redux/api/auth/authApi";
function Navbar({ collapseSidenav, onColorCombinationChange, bgColor, navbarTextHeadingColor }) {
  const settingDesktop = useRef(null);
  const settingMobile = useRef(null);
  const navigate = useNavigate();
  const togglePopup = (ref) => {
    const currentRef = ref === "desktop" ? settingDesktop : settingMobile;
    currentRef.current.classList.toggle("d-none");
  };

  const notificationDesktop = useRef(null); // New ref for notification popup
  const notificationMobile = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  useEffect(() => {
    const data = async () => {
      try {
        const resp = await getNotificationApi(localStorage.getItem("userId"));
        console.log("notifaction", resp);

        setNotifications(resp?.data?.data);
        setUnreadCount(resp?.data?.data?.filter((n) => !n.isRead).length);
      } catch (error) {
        console.log(error);
      }
    };
    data();
  }, []);
  // Existing useEffect for closing popups (updated)
  useEffect(() => {
    const handleClickOutside = (e) => {
      // Existing setting popups
      if (settingDesktop.current && !settingDesktop.current.contains(e.target)) {
        settingDesktop.current.classList.add("d-none");
      }
      if (settingMobile.current && !settingMobile.current.contains(e.target)) {
        settingMobile.current.classList.add("d-none");
      }

      // New notification popups
      if (notificationDesktop.current && !notificationDesktop.current.contains(e.target)) {
        notificationDesktop.current.classList.add("d-none");
      }
      if (notificationMobile.current && !notificationMobile.current.contains(e.target)) {
        notificationMobile.current.classList.add("d-none");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleNotificationPopup = (type) => {
    const ref = type === "desktop" ? notificationDesktop : notificationMobile;
    ref.current.classList.toggle("d-none");
  };

  // Mark notification as read
  const markAsRead = (id) => {
    setNotifications((prev) => prev.map((notification) => (notification.ROWID === id ? { ...notification, isRead: true } : notification)));
    setUnreadCount((prev) => prev - 1);
    updateNoticationApi(id);
  };

  // Mark all as read
  const markAllAsRead = () => {
    setNotifications((prev) => prev.map((notification) => ({ ...notification, isRead: true })));
    setUnreadCount(0);
    markAllReadNoticationApi(localStorage.getItem("userId"));
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (settingDesktop.current && !settingDesktop.current.contains(e.target)) {
        settingDesktop.current.classList.add("d-none");
      }
      if (settingMobile.current && !settingMobile.current.contains(e.target)) {
        settingMobile.current.classList.add("d-none");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = () => {
    if (settingDesktop.current) {
      settingDesktop.current.classList.add("d-none");
    }
  };

  //to show add & delete button according to permissions
  const permissions = localStorage.getItem("permissions");
  const filterData = permissions ? JSON.parse(permissions) : [];
  const name = localStorage.getItem("name");

  const requiredPermissions = ["add", "viewAll", "fullAccess", "modifyAll", "delete", "assignOwner"];

  // Check if all modules have all required permissions set to true
  const allModulesHaveFullPermissions = Array.isArray(filterData) && filterData.length > 0 && filterData.every((module) => requiredPermissions.every((permission) => module[permission] === true));

  const handelLogout = async () => {
    localStorage.clear();
    navigate("/");
    handleOptionClick();
    userLogout();
  };

  // Format time difference
  const formatTime = (date) => {
    const d = typeof date === "string" ? new Date(date) : date;
    if (!(d instanceof Date) || isNaN(d)) return "Invalid date";
    const diff = Date.now() - d.getTime();
    const mins = Math.floor(diff / 60000);
    const hours = Math.floor(mins / 60);
    const days = Math.floor(hours / 24);

    if (mins < 1) return "Just now";
    if (mins < 60) return `${mins} min ago`;
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    return `${days} day${days > 1 ? "s" : ""} ago`;
  };


//   const handleNotificationClick = (id) => {
//   const notification = notifications.find((n) => n.ROWID === id);
//   if (!notification.isRead) {
//     markAsRead(id);
//   }
  
//   // Close both popups to be safe
//   notificationDesktop.current?.classList.add("d-none");
//   notificationMobile.current?.classList.add("d-none");
  
//   navigate("/lead-list", {state: {fromNotification: true}});
// };


const handleNotificationClick = (id) => {
  const notification = notifications.find((n) => n.ROWID === id);
  
  // Check if module is "leads" before navigating
  if (notification.module === "leads") {
    if (!notification.isRead) {
      markAsRead(id);
    }
    
    // Close both popups to be safe
    notificationDesktop.current?.classList.add("d-none");
    notificationMobile.current?.classList.add("d-none");
    
    // Navigate with moduleRowid in state
    navigate("/lead-list", {
      state: {
        fromNotification: true,
        moduleRowid: notification.moduleRowid
      }
    });
  }if(notification.module === "tasks"){
    if (!notification.isRead) {
      markAsRead(id);
    }
    
    // Close both popups to be safe
    notificationDesktop.current?.classList.add("d-none");
    notificationMobile.current?.classList.add("d-none");
    
    // Navigate with moduleRowid in state
    navigate("/taskmaster", {
      state: {
        fromNotification: true,
        moduleRowid: notification.moduleRowid
      }
    });
  }

   else {
    // If module is not "leads", just mark as read and close popup
    if (!notification.isRead) {
      markAsRead(id);
    }
    
    // Close both popups
    notificationDesktop.current?.classList.add("d-none");
    notificationMobile.current?.classList.add("d-none");
    
    // Optional: You can show a message or handle other modules differently
    console.log(`Notification module is ${notification.module}, navigation not implemented`);
  }
};

  
  return (
    <>
      <nav className="navbar d-none d-sm-block" style={{ backgroundColor: "#F0F0F0" }}>
        <div className="nav-main-div">
          <button onClick={collapseSidenav} className="px-1">
            <Menu />
          </button>
          <ul>
            <li className="position-relative mx-2">
              <button onClick={() => toggleNotificationPopup("desktop")} className=" position-relative  p-2" aria-label="Notifications" style={{ minWidth: 44, minHeight: 44 }}>
                {unreadCount > 0 && (
                  <span
                    className="position-absolute translate-middle badge rounded-pill"
                    style={{
                      background: "#e53935", // red
                      color: "#fff", // white text
                      minWidth: 22,
                      height: 22,
                      top: "5px",
                      left: "70%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      fontSize: 13,
                      zIndex: 2,
                      padding: "0 6px",
                      border: "2px solid #fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
                    }}
                  >
                    {unreadCount}
                    <span className="visually-hidden">unread notifications</span>
                  </span>
                )}
                {unreadCount > 0 ? <BellDot size={22} /> : <Bell size={22} />}
              </button>

              <div ref={notificationDesktop} className="notification-sidebar d-none" tabIndex={-1}>
                <div className="sidebar-header d-flex justify-content-between align-items-center px-4 py-3">
                  <h5 className="mb-0 fw-bold text-success">Notifications</h5>
                  {unreadCount > 0 && (
                    <button onClick={markAllAsRead} className="btn btn-outline-success btn-sm ms-2" style={{ fontSize: "0.8rem", padding: "2px 10px" }}>
                      Mark all as read
                    </button>
                  )}
                  {notifications.length > 0 && (
                    <button
                      onClick={() => {
                        setNotifications([]);
                        setUnreadCount(0);
                        clearAllNotificationApi(localStorage.getItem("userId"));
                      }}
                      className="btn btn-outline-danger btn-sm ms-2"
                      style={{ fontSize: "0.8rem", padding: "2px 10px" }}
                    >
                      Clear all
                    </button>
                  )}
                  <button className=" ms-2" onClick={() => toggleNotificationPopup("desktop")} aria-label="Close" style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                    &times;
                  </button>
                </div>
                <div className="sidebar-content px-3 pb-3">
                  <div className="list-group list-group-flush" style={{ maxHeight: 400, overflowY: "auto", background: "transparent" }}>
                    {notifications?.length > 0 ? (
                      notifications?.map((notification) => (
                        <button
                          key={notification.ROWID}
                          className={`list-group-item list-group-item-action d-flex gap-3 align-items-start border-0 shadow-sm mb-2 notification-panel-item ${
                            notification.isRead ? "read-task" : "unread-task"
                          }`}
                          onClick={() => handleNotificationClick(notification?.ROWID)}
                          style={{
                            borderRadius: "0.75rem",
                            transition: "background 0.2s, border-left 0.2s",
                            background: notification.isRead ? "#fff" : "linear-gradient(90deg, #e8fafd 0%, #e9fce9 100%)",
                            borderLeft: "8px solid",
                            borderImage: notification.isRead ? "linear-gradient(180deg, #e0e0e0 0%, #f8fafc 100%) 1" : "linear-gradient(180deg, #3ec6ff 0%, #6ee7b7 50%, #fff 100%) 1",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                            padding: "12px 16px 12px 10px",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <span className="mt-1">{!notification.isRead ? <CircleDot size={18} className="text-success" /> : <CheckCircle size={18} className="text-secondary" />}</span>
                          <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-center">
                              <strong className="text-dark">{notification.title}</strong>
                              <small className="text-muted ms-2">{formatTime(notification.CREATEDTIME)}</small>
                            </div>
                            <div className="small text-secondary">{notification.body}</div>
                            {/* <div className="small text-secondary">{notification.module}</div> */}
                            {/* <div className="small text-secondary">{notification.moduleRowid}</div> */}
                          </div>
                        </button>
                      ))
                    ) : (
                      <div className="list-group-item text-center text-success-50 py-4 bg-transparent border-0">
                        <span className="fw-light">No notifications</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </li>

            {allModulesHaveFullPermissions && (
              <li>
                <Link to="/user-role">
                  <Settings />
                </Link>
              </li>
            )}
            <li className="position-relative">
              <Wrap>
                <WrapItem>
                  <Avatar onClick={() => togglePopup("desktop")} size="sm" name={name} src="https://bit.ly/tioluwani-kolawole" />
                </WrapItem>
              </Wrap>
              <div ref={settingDesktop} className={`popup-div d-none px-0`}>
                <div className="border-bottom w-100 mb-2">
                  <h5 className="mx-3 mt-3" style={{ color: "green" }}>
                    {name}
                  </h5>
                </div>
                {allModulesHaveFullPermissions && (
                  <div className="border-bottom w-100 list-div mb-2">
                    <Link to="/user-role" onClick={handleOptionClick}>
                      <p className="mb-0 me-2 ms-3">Roles</p>
                    </Link>
                  </div>
                )}
                <div className="border-bottom w-100 list-div mb-2">
                  <div className="border-bottom w-100 list-div mb-2">
                    <button
                      onClick={handelLogout}
                      style={{
                        background: "none",
                        border: "none",
                        width: "100%",
                        textAlign: "left",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                      }}
                    >
                      <p className="mb-0 me-2 ms-3">Sign Out</p>
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>

      <nav className="navbar d-block d-sm-none" style={{ backgroundColor: "#F0F0F0" }}>
        <div className="nav-main-div d-flex justify-content-end">
          <ul>
            <li className="position-relative mx-2">
              <button onClick={() => toggleNotificationPopup("mobile")} className="position-relative p-2" style={{ minWidth: 44, minHeight: 44 }}>
                {unreadCount > 0 && (
                  <span
                    className="position-absolute translate-middle badge rounded-pill"
                    style={{
                      background: "#e53935",
                      color: "#fff",
                      minWidth: 22,
                      height: 22,
                      top: "5px",
                      left: "70%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      fontSize: 13,
                      zIndex: 2,
                      padding: "0 6px",
                      border: "2px solid #fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
                    }}
                  >
                    {unreadCount}
                  </span>
                )}
                {unreadCount > 0 ? <BellDot size={22} /> : <Bell size={22} />}
              </button>

              {/* Mobile Notification Popup */}
              <div
                ref={notificationMobile}
                className="mobile-notification-popup d-none"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 1050,
                  backgroundColor: "#fff",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                  <h5 className="mb-0 fw-bold text-success">Notifications</h5>
                  <div>
                    {unreadCount > 0 && (
                      <button onClick={markAllAsRead} className="btn btn-outline-success btn-sm me-2">
                        Mark all
                      </button>
                    )}
                    {notifications.length > 0 && (
                      <button
                        onClick={() => {
                          setNotifications([]);
                          setUnreadCount(0);
                          clearAllNotificationApi(localStorage.getItem("userId"));
                        }}
                        className="btn btn-outline-danger btn-sm ms-2"
                        style={{ fontSize: "0.8rem", padding: "2px 10px" }}
                      >
                        Clear all
                      </button>
                    )}
                    <button onClick={() => toggleNotificationPopup("mobile")} className="btn btn-sm">
                      <X size={20} />
                    </button>
                  </div>
                </div>
                <div className="flex-grow-1 p-3" style={{ overflowY: "auto" }}>
                  {notifications.length > 0 ? (
                    notifications.map((notification) => (
                      <div
                        key={notification.ROWID}
                        className={`d-flex gap-3 align-items-start p-3 mb-2 rounded ${notification.isRead ? "bg-light" : "bg-info bg-opacity-10"}`}
                        onClick={() => handleNotificationClick(notification.ROWID)}
                      >
                        <span className="mt-1">{!notification.isRead ? <CircleDot size={18} className="text-success" /> : <CheckCircle size={18} className="text-secondary" />}</span>
                        <div className="flex-grow-1">
                          <div className="d-flex justify-content-between">
                            <strong className="text-dark">{notification.title}</strong>
                            <small className="text-muted">{formatTime(notification.CREATEDTIME)}</small>
                          </div>
                          <div className="small text-secondary">{notification.body}</div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-5 text-muted">
                      <span>No notifications</span>
                    </div>
                  )}
                </div>
              </div>
            </li>

            {allModulesHaveFullPermissions && (
              <li>
                <Link to="/user-role">
                  <Settings />
                </Link>
              </li>
            )}
            <li className="position-relative">
              <Wrap>
                <WrapItem>
                  <Avatar onClick={() => togglePopup("mobile")} size="sm" name={name} src="https://bit.ly/tioluwani-kolawole" />
                </WrapItem>
              </Wrap>
              <div
                ref={settingMobile}
                className="popup-div d-none px-0"
                style={{
                  position: "absolute",
                  top: "100%",
                  right: "10px",
                  zIndex: 1000,
                  width: "200px",
                }}
              >
                <div className="border-bottom w-100">
                  <h5 className="mx-3 mt-3" style={{ color: "green" }}>
                    {name}
                  </h5>
                </div>
                {allModulesHaveFullPermissions && (
                  <div className="border-bottom w-100 list-div">
                    <Link to="/user-role" onClick={() => settingMobile.current.classList.add("d-none")}>
                      <p className="mb-0 me-2 ms-3">Roles</p>
                    </Link>
                  </div>
                )}
                <div className="w-100 list-div">
                  <button onClick={handelLogout} className="w-100 text-start bg-transparent border-0 ps-3">
                    <p className="mb-0">Sign Out</p>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}
export default Navbar;
